module.exports = __webpack_public_path__ + "static/CFG_Artist_SanFernando-922333c9ab14e682950ee188c4924b8a.jpeg";